











































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import Pdf from 'vue-pdf'
import * as Helper from '@/helpers'

@Component({
  components: {Pdf},
})
export default class ItThumb extends Vue {
  @Prop({type: Array, required: true}) value!: string[]
  @Prop({type: String, default: null}) title!: string | null
  @Prop({type: String, default: null}) titleImg!: string | null
  @Prop({type: Number, default: 4}) split!: number
  @Prop({type: Boolean, default: false}) useAnchor!: boolean
  @Prop({type: Boolean, default: false}) removable!: boolean

  Helper = Helper

  urls: string[] = []

  get desSplit() {
    return this.split
  }

  get tabSplit() {
    return Math.max(1, this.split - 1)
  }

  get mobSplit() {
    return Math.max(1, this.split - 2)
  }

  @Watch('value', {deep: true, immediate: true})
  valueEvent(val: string[]) {
    this.urls = val
  }

  remove(index: number) {
    this.urls.splice(index, 1)
    this.$emit('input', this.urls)
  }

  open(url: string) {
    if (Helper.isImgFile(url)) {
      this.openImageDisplay(url)
    } else {
      Helper.openUrl(url, true)
    }
  }

  openImageDisplay(src: string) {
    this.$modal.open('imageDisplay', {src, showDownload: true})
  }
}
